import React from 'react';
import queryString from 'query-string';
import { connect } from 'react-redux';
import _ from "lodash";
import { CommonLayout } from '../common/CommonLayout';
import { setInitStorage } from '../common/InitLocalStore';
import { sortingData } from '../common/Util';
import { ErrorModal } from '../common/ErrorModal';
import { ActionLoadingModal } from '../common/ActionLoadingModal';
import moment from 'moment';
import AddAllowedBlockedItemModal from './AddAllowedBlockedItemModal';
import UpdateAllowedBlockedItemModal from './UpdateAllowedBlockedItemModal'
import GlobalSettingsResponseModal from '../common/GlobalSettingsResponseModal';
import { getTenantList, getAllowedBlockedList, clearAllowedBlockedTable, clearTenantErrorResponseMessage, clearAllowedBlockedErrorResponseMessage, sendAllowedBlockedItem, updateAllowedBlockedItem, sendRequestAllowedBlockedDelete, clearNextPossibleResponseMessage } from '../../services/apiOperations';
import TableGrid from '../common/TableGrid';
import MultiSelectTextbox from '../common/MultiSelectTextbox';
import ConfirmationModal from '../common/ConfirmationModal';
import 'bootstrap/dist/css/bootstrap.css';
import '../../assets/css/tableGrid.scss';
import ReactTooltip from 'react-tooltip';
import { ToastContainer, toast } from 'react-toastify';
import { ALLOWED_TYPE_OPTIONS } from '../common/Constants';

if (process.env.REACT_APP_HOST_ENV === "production") {
    console.log = function () { }
}

const CONSTANT_TYPE = {
    selectedTenant: "selectedTenant",
    allowedBlockedName: "allowedBlockedName",
    fileName: "fileName",
    path: "path",
    sha256: "sha256",
    certificateSigner: "certificateSigner",
    endpointName: "endpointName",
    allowedActions: "allowedActions",
    allowedBlocked: "allowedBlocked",
    dateRange: "dateRange",
    machineName: "machineName",
    type: "type"
}



const mapStateToProps = state => ({
    ...state
})

const mapDispatchToProps = dispatch => ({
    getAllowedBlockedList: (referrer, queryFilterString, force) => dispatch(getAllowedBlockedList(referrer, queryFilterString, force)),
    clearNextPossibleResponseMessage: () => dispatch(clearNextPossibleResponseMessage()),
    getTenantList: (referrer, queryFilterString) => dispatch(getTenantList(referrer, queryFilterString)),
    clearAllowedBlockedTable: () => dispatch(clearAllowedBlockedTable()),
    clearAllowedBlockedErrorResponseMessage: () => dispatch(clearAllowedBlockedErrorResponseMessage()),
    clearTenantErrorResponseMessage: () => dispatch(clearTenantErrorResponseMessage()),
})

const allowedBlockedOptions = [
    { value: "allowed", label: "Allowed" },
    { value: "blocked", label: "Blocked" }
]

const NULL_UNDEFINED_EMPTY_CHECK = [null, undefined, ""]

class AllowedBlockedItems extends React.Component {
    constructor(props) {
        super(props);
        this.addAllowedBlockedModalRef = React.createRef();
        setInitStorage(props.referrerHostname, queryString.parse(props.location.search))
        this.state = {
            queryParams: queryString.parse(props.location.search),
            kaseyaParams: queryString.parse(props.location.search),
            tenantList: [],
            filtered: [],
            rowData: [],
            stopInterval: false,
            updateInterval: false,
            clearFilterBool: false,
            clearSearchBox: false,
            selectedAction: '',
            showActionAllowedBlocked: false,
            showErrorActionAllowedBlocked: false,
            actionAllowedBlockedMessage: '',
            columnDefs: [
                {
                    text: "Tenant Name", dataField: "tenant.name", sort: true, onSort: this.onSortChange, formatter: (cell) => {
                        if (!NULL_UNDEFINED_EMPTY_CHECK.includes(cell))
                            return cell
                        else
                            return "-"
                    }
                },
                {
                    text: "Allowed/Blocked", dataField: "allowedBlockedName", sort: true, onSort: this.onSortChange, width: 200, formatter: (cell) => {
                        if (!NULL_UNDEFINED_EMPTY_CHECK.includes(cell))
                            return cell
                        else
                            return "-"
                    }
                },
                {
                    text: "File Name", dataField: 'properties.fileName', sort: true, onSort: this.onSortChange, width: 80, formatter: (cell) => {
                        if (!NULL_UNDEFINED_EMPTY_CHECK.includes(cell))
                            return cell
                        else
                            return "-"
                    }
                },
                {
                    text: "Path", dataField: "properties.path", sort: true, onSort: this.onSortChange, width: 150, formatter: (cell) => {
                        if (!NULL_UNDEFINED_EMPTY_CHECK.includes(cell))
                            return cell
                        else
                            return "-"
                    }
                },
                {
                    text: "SHA256", dataField: "properties.sha256", sort: true, onSort: this.onSortChange, width: 150, formatter: (cell) => {
                        if (!NULL_UNDEFINED_EMPTY_CHECK.includes(cell))
                            return cell
                        else
                            return "-"
                    }
                },
                {
                    text: "Certificate Signer", dataField: "properties.certificateSigner", sort: true, onSort: this.onSortChange, width: 150, formatter: (cell) => {
                        if (!NULL_UNDEFINED_EMPTY_CHECK.includes(cell))
                            return cell
                        else
                            return "-"
                    }
                },
                {
                    text: "Affected Endpoint Name", dataField: "originEndpoint.name", sort: true, onSort: this.onSortChange, width: 200, formatter: (cell) => {
                        if (!NULL_UNDEFINED_EMPTY_CHECK.includes(cell))
                            return cell
                        else
                            return "-"
                    }
                },
                {
                    text: "Comment", dataField: "comment", sort: true, onSort: this.onSortChange, width: 150, formatter: (cell) => {
                        if (!NULL_UNDEFINED_EMPTY_CHECK.includes(cell))
                            return cell
                        else
                            return "-"
                    }
                },
                {
                    text: "Created User", dataField: "createdBy.name", sort: true, onSort: this.onSortChange, width: 150, formatter: (cell) => {
                        if (!NULL_UNDEFINED_EMPTY_CHECK.includes(cell))
                            return cell
                        else
                            return "-"
                    }
                },
                {
                    text: "Created At", dataField: "createdAt", sort: true, formatter: (cell, row) => {
                        if (!NULL_UNDEFINED_EMPTY_CHECK.includes(row))
                            if (!NULL_UNDEFINED_EMPTY_CHECK.includes(row.createdAt))
                                return (moment(row.createdAt).format("DD-MMM-YYYY HH:mm"))
                            else
                                return "-"
                        else
                            return "-"
                    }, onSort: this.onSortChange, width: 150
                },
                {
                    text: "Updated At", dataField: "updatedAt", sort: true, formatter: (cell, row) => {
                        if (!NULL_UNDEFINED_EMPTY_CHECK.includes(row))
                            if (!NULL_UNDEFINED_EMPTY_CHECK.includes(row.updatedAt))
                                return (moment(row.updatedAt).format("DD-MMM-YYYY HH:mm"))
                            else
                                return "-"
                        else
                            return "-"
                    }, onSort: this.onSortChange, width: 150
                }
            ],
            defaultSorted: [{
                dataField: 'createdDate',
                order: 'desc'
            }],
            currentPage: 1,
            pageWiseSelectedRows: [],
            loadingAction: false,
            sortChangeBool: false,
            successCount: 0,
            failCount: 0,
            clearSelection: false,
            selectedAllowedBlockedBody: [],
            showDeleteConfirmationModal: false,
            DeleteConfirmationModalMessage: '',
            showAddAllowedBlockedItemModal: false,
            showUpdateAllowedBlockedItemModal: false,
            showGlobalSettingsResponseModal: false,
            messageGlobalSettingsResponseModal: '',
            machineName: "",
        }
        this.componentWillMountFunction()
    }

    componentWillMountFunction = () => {
        let queryFitlerString = queryString.parse(this.props.location.search)
        if (queryFitlerString !== "") {
            if (this.props.location.filtersObject) {
                let filters = this.state.filtered
                if (this.props.location.state) {
                    let newPropsSelectedTenantId = { value: this.props.location.state.id, type: CONSTANT_TYPE.selectedTenant }
                    filters.push(newPropsSelectedTenantId)
                }
                this.setState({
                    filtered: filters
                })
            }
            this.props.getTenantList(this.props.referrerHostname + "_" + localStorage.getItem(this.props.referrerHostname + "_kaseya_tenant_id"), this.props.location.search);
        }
        else {
            this.props.getTenantList(this.props.referrerHostname + "_" + localStorage.getItem(this.props.referrerHostname + "_kaseya_tenant_id"));
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.allowed_blocked.force_limit_reached || this.props.allowed_blocked.queued_job_exist || this.props.allowed_blocked.scheduled) {
            this.showToast();
            this.props.allowed_blocked.queued_job_exist = null
            this.props.allowed_blocked.force_limit_reached = null
            this.props.allowed_blocked.scheduled = null
            this.clearErrorResponseToast()
        }
        if (JSON.stringify(this.props.allowed_blocked.allowed_blocked_list) !== JSON.stringify(prevState.rowData)) {
            this.setState({
                rowData: this.props.allowed_blocked.allowed_blocked_list
            })
            this.clearErrorResponseToast()
        }
        if (JSON.stringify(this.props.allowed_blocked.error_response_message) !== JSON.stringify(prevProps.allowed_blocked.error_response_message)) {
            this.setState({
                allowedBlockedErrorResponse: this.props.allowed_blocked.error_response_message
            })
        }
        if (JSON.stringify(this.props.tenants.tenant_list) !== JSON.stringify(prevProps.tenants.tenant_list)) {
            let createTenantListPair = []
            this.props.tenants.tenant_list.forEach((element) => {
                createTenantListPair.push({ value: element.id, label: element.showAs })
            })
            this.setState({
                tenantList: createTenantListPair
            })
            if (this.props.location.state === undefined) {
                this.getAllowedBlockedData(false, false)
            }
        }
        if (
            this.props.settings.SophosIdTypeIsTenant &&
            JSON.stringify(this.props.settings.SophosIdTypeIsTenant) !==
            JSON.stringify(prevProps.settings.SophosIdTypeIsTenant)
        ) {
            this.getAllowedBlockedData();
            const columDefs = [...this.state.columnDefs];
            const withoutTenantColumnDefs = _.remove(
                columDefs,
                (cols) => cols.dataField !== "tenant.name"
            );
            this.setState({ columnDefs: withoutTenantColumnDefs });
        }
    }

    componentWillUnmount() {
        this.clearErrorResponseToast()
        this.clearTenantErrorResponseToast()
    }

    onSortChange = () => {
        this.setState({
            sortChangeBool: !this.state.sortChangeBool
        })
    }

    updateTime() {
        this.setState({
            updateInterval: !this.state.updateInterval
        })
    }
    clearNextpossibleToast = () => {
        this.props.clearNextPossibleResponseMessage()
    }

    showToast = () => {
        if (this.props.allowed_blocked.force_limit_reached) {
            let last_sync_time = new Date(this.props.allowed_blocked.last_force_update_time * 1000)
            let req_per_hour_diff = Math.round(60 / this.props.allowed_blocked.req_per_hour)
            let next_response_time = new Date((this.props.allowed_blocked.last_force_update_time * 1000) + (1000 * 60 * req_per_hour_diff))
            toast.error(`Last sync ran at ${last_sync_time.toLocaleTimeString()}. Next available sync at ${next_response_time.toLocaleTimeString()}`, { containerId: 'A', onClose: () => this.clearNextpossibleToast() });
        }
        else if (this.props.allowed_blocked.queued_job_exist) {
            toast.error("Job already exist in queue", { containerId: 'A', onClose: () => this.clearNextpossibleToast() });
        }
        else if (this.props.allowed_blocked.scheduled) {
            toast.success("Force sync job scheduled successfuly", { containerId: 'A', onClose: () => this.clearNextpossibleToast() });
        }
    }

    clearNextpossibleToast = () => {
        this.props.clearNextPossibleResponseMessage()
    }

    showToast = () => {
        if (this.props.allowed_blocked.force_limit_reached) {
            let last_sync_time = new Date(this.props.allowed_blocked.last_force_update_time * 1000)
            let req_per_hour_diff = Math.round(60 / this.props.allowed_blocked.req_per_hour)
            let next_response_time = new Date((this.props.allowed_blocked.last_force_update_time * 1000) + (1000 * 60 * req_per_hour_diff))
            toast.error(`Last sync ran at ${last_sync_time.toLocaleTimeString()}. Next available sync at ${next_response_time.toLocaleTimeString()}`, { containerId: 'A', onClose: () => this.clearNextpossibleToast() });
        }
        else if (this.props.allowed_blocked.queued_job_exist) {
            toast.error("Job already exist in queue", { containerId: 'A', onClose: () => this.clearNextpossibleToast() });
        }
        else if (this.props.allowed_blocked.scheduled) {
            toast.success("Force sync job scheduled successfuly", { containerId: 'A', onClose: () => this.clearNextpossibleToast() });
        }
    }

    filterData = (data) => {
        let result = []
        let appliedFilterLength = this.state.filtered.length;
        if (appliedFilterLength > 0) {
            for (let i = 0; i < data.length; i++) {
                let matchedCount = 0
                for (let j = 0; j < appliedFilterLength; j++) {
                    if (this.state.filtered[j].type === CONSTANT_TYPE.selectedTenant && data[i]["tenant"] && data[i]["tenant"]["id"].includes(this.state.filtered[j].value)) {
                        matchedCount++;
                    }
                    if (this.state.filtered[j].type === CONSTANT_TYPE.type && (this.state.filtered[j].value.toLowerCase() === "all" || data[i]["type"].toLowerCase() === this.state.filtered[j].value.toLowerCase())) {
                        matchedCount++;
                    }
                    if (this.state.filtered[j].type === CONSTANT_TYPE.machineName && data[i]["originEndpoint"] && data[i]["originEndpoint"]["name"].toLowerCase().includes(this.state.filtered[j].value.toLowerCase())) {
                        matchedCount++;
                    }
                    if (this.state.filtered[j].type === CONSTANT_TYPE.allowedBlocked && (this.state.filtered[j].value.toLowerCase() === "all" || data[i]["allowedBlockedName"].toLowerCase() === this.state.filtered[j].value.toLowerCase())) {
                        matchedCount++;
                    }
                }
                if (matchedCount === appliedFilterLength) {
                    result.push(data[i])
                }
            }
        } else {
            result = [...data]
        }
        return result
    }

    getPageWiseSelectedRowsFromTable = (currentPage, selectedRowData) => {
        let selectedAllowedBlockedBody = []
        selectedRowData.forEach((eachPage) => {
            eachPage.selectedRow.forEach((eachRow) => {
                selectedAllowedBlockedBody.push(eachRow)
            })
        })
        this.setState({
            currentPage: currentPage,
            pageWiseSelectedRows: selectedRowData,
            selectedAllowedBlockedBody: selectedAllowedBlockedBody,
        })
    }

    setTablePage = (page) => {
        this.setState({
            currentPage: page,
        })
    }

    findFilterValueByType(arrayValue, searchType) {
        return arrayValue.type === searchType
    }

    selectFilters = (value, type, intervalInit = false) => {

        let filters = this.state.filtered
        if (type === CONSTANT_TYPE.machineName) {
            this.setState({ machineName: value });
        }
        if (type !== CONSTANT_TYPE.dateRange) {
            let newfilterObj = { value: value, type: type }
            const obj = filters.find((arrayValue) => this.findFilterValueByType(arrayValue, newfilterObj.type))
            if (obj !== undefined) {
                const index = filters.indexOf(obj)
                filters.splice(index, 1)
            }
            if (value !== '')
                filters.push(newfilterObj)
            this.setState({
                filtered: filters,
                clearSearchBox: !this.state.clearSearchBox
            })
        }
    }

    clearFilter() {
        let filters = []
        this.setState({ machineName: "" });
        this.setState({ filtered: filters, clearFilterBool: !this.state.clearFilterBool, updateInterval: !this.state.updateInterval, stopInterval: false, selectedAction: "" })
    }

    getAllowedBlockedData(fromOtherFilter = false, intervalInit = false, force = false) {
        if (this.props.location.search !== "") {
            if (!force) {
                this.props.clearAllowedBlockedTable()
            }
            const queryParams = queryString.parse(this.props.location.search)
            if (force) {
                let filters = this.state.filtered;
                let filteredObject = filters.find((arrayValue) => this.findFilterValueByType(arrayValue, CONSTANT_TYPE.selectedTenant));
                if (filteredObject) {
                    queryParams.sophosTenantId = filteredObject.value
                }
            }
            const queryFilter = queryString.stringify(queryParams)
            this.props.getAllowedBlockedList(this.props.referrerHostname + "_" + localStorage.getItem(this.props.referrerHostname + "_kaseya_tenant_id"), "?" + queryFilter, force)
        }
        else {
            this.props.getAllowedBlockedList(this.props.referrerHostname + "_" + localStorage.getItem(this.props.referrerHostname + "_kaseya_tenant_id"), force)
        }
    }

    getAllowedBlockedSelectedId = (selectedId) => {
        this.setState({
            singleSelectedAllowedBlockedId: selectedId
        })
    }

    tablegridMessage() {
        if (!this.props.allowed_blocked.is_loading) {
            let filteredObject = this.state.filtered.find((arrayValue) => this.findFilterValueByType(arrayValue, CONSTANT_TYPE.selectedTenant))
            if (filteredObject !== undefined) {
                let checkTenantDetails = this.props.tenants.tenant_list.find((tenantValue) => tenantValue.id === filteredObject.value)
                if (checkTenantDetails) {
                    if (checkTenantDetails.apiHost === null || checkTenantDetails.apiHost === "" || checkTenantDetails.apiHost === "NULL" || checkTenantDetails.apiHost === "null" || checkTenantDetails.apiHost === undefined) {
                        return { message: 'This account has not been activated; <br/>Please activate from <a target="_blank" href="https://cloud.sophos.com/">Sophos Central Administration Console</a>', type: "error" }
                    }
                    else {
                        return { message: "No Allowed or Blocked Items found to match your search.", type: "info" }
                    }
                }
                else {
                    return { message: "No Allowed or Blocked Items found to match your search.", type: "info" }
                }

            }
            else {
                return { message: "No Allowed or Blocked Items found to match your search.", type: "info" }
            }
        }
        else {
            return { message: "Loading....", type: "info" }
        }
    }

    handleActionChangeFilter = (value) => {
        if (value === "") {
            this.setState({
                selectedAction: "",
                clearSelection: !this.state.clearSelection
            }, () => this.selectFilters("", CONSTANT_TYPE.allowedActions))
        }
        else {
            this.setState({
                selectedAction: value,
                clearSelection: !this.state.clearSelection
            }, () => this.selectFilters(value, CONSTANT_TYPE.allowedActions))
        }
    }

    clearErrorResponseToast = () => {
        this.props.clearAllowedBlockedErrorResponseMessage()
    }

    clearTenantErrorResponseToast = () => {
        this.props.clearTenantErrorResponseMessage()
    }

    getNonSelectableRows = (allRows) => {
        let allNonselectableRowIds = []
        if (this.state.selectedAction !== "") {
            allRows.forEach((element) => {
                if (element.allowedBlockedAction) {
                    allNonselectableRowIds.push(element.id)
                }
            })
        }
        else {
            allNonselectableRowIds = []
        }
        return allNonselectableRowIds
    }

    closeActionAllowedBlocked = () => {
        if (this.state.pageWiseSelectedRows.length === 0 || this.state.pageWiseSelectedRows[0].selectedRow.length === 0) {
            this.setState({
                showErrorActionAllowedBlocked: false,
                showActionAllowedBlocked: false,
                actionAllowedBlockedMessage: ""
            })
        }
        else {
            this.setState({
                showActionAllowedBlocked: false,
                showErrorActionAllowedBlocked: false,
                actionAllowedBlockedMessage: "",
                clearSearchBox: !this.state.clearSearchBox,
                selectedAction: ""
            }, () => {
                this.getAllowedBlockedData()
                this.selectFilters("", CONSTANT_TYPE.allowedActions)
            })
        }
    }

    AddAllowedBlockedActionHandler = (ItemData) => {
        let allowed_or_block = "blocked"
        if (ItemData.allowed) {
            allowed_or_block = "allowed"
        }
        this.setState({
            loadingAction: true,
            // showAddAllowedBlockedItemModal:false,
            actionAllowedBlockedMessage: ""
        }, () => {
            let requestBody = ItemData
            sendAllowedBlockedItem(requestBody, this.props.referrerHostname + "_" + localStorage.getItem(this.props.referrerHostname + "_kaseya_tenant_id"), this.props.location.search)
                .then((res) => {
                    this.setState({
                        loadingAction: false,
                        showAddAllowedBlockedItemModal: false,
                        showGlobalSettingsResponseModal: true,
                        messageGlobalSettingsResponseModal: `${allowed_or_block.charAt(0).toUpperCase() + allowed_or_block.slice(1)} item added successfully.`
                    }, this.getAllowedBlockedData)
                    this.setState({
                        updateInterval: !this.state.updateInterval
                    })
                })
                .catch((err) => {
                    let errMessage = ""
                    if (err.response) {
                        if (err.response.data.message !== undefined)
                            errMessage = err.response.data.message
                        else
                            errMessage = "Something went wrong; Please try again later."
                    }
                    else {
                        errMessage = "Something went wrong; Please try again later."
                    }
                    this.setState({
                        loadingAction: false,
                        showErrorActionAllowedBlocked: true,
                        actionAllowedBlockedMessage: errMessage
                    })
                })
        })
    }


    UpdateAllowedBlockedActionHandler = (ItemData) => {
        this.setState({
            loadingAction: true,
            actionAllowedBlockedMessage: ""
        }, () => {
            let requestBody = ItemData
            updateAllowedBlockedItem(requestBody, this.props.referrerHostname + "_" + localStorage.getItem(this.props.referrerHostname + "_kaseya_tenant_id"), this.props.location.search)
                .then((res) => {
                    this.setState({
                        loadingAction: false,
                        showUpdateAllowedBlockedItemModal: false,
                        showGlobalSettingsResponseModal: true,
                        messageGlobalSettingsResponseModal: "Allowed item updated successfully."
                    }, this.getAllowedBlockedData)
                    this.setState({
                        updateInterval: !this.state.updateInterval
                    })
                })
                .catch((err) => {
                    let errMessage = ""
                    if (err.response) {
                        if (err.response.data.message !== undefined)
                            errMessage = err.response.data.message
                        else
                            errMessage = "Something went wrong; Please try again later."
                    }
                    else {
                        errMessage = "Something went wrong; Please try again later."
                    }
                    this.setState({
                        loadingAction: false,
                        showErrorActionAllowedBlocked: true,
                        actionAllowedBlockedMessage: errMessage
                    })
                })
        })
    }

    UpdateAllowedBlockedAction = () => {
        this.setState({
            showUpdateAllowedBlockedItemModal: true,
        })
    }

    CloseUpdateAllowedBlockedAction = () => {
        this.setState({
            showUpdateAllowedBlockedItemModal: false,
        })
    }

    AddAllowedBlockedAction = () => {
        if (this.addAllowedBlockedModalRef && this.addAllowedBlockedModalRef.current) {
            this.addAllowedBlockedModalRef.current.handleItemTypeChange("allowed");
        }
        this.setState({
            showAddAllowedBlockedItemModal: true,
        });
    }

    CloseAllowedBlockedAction = () => {
        this.setState({
            showAddAllowedBlockedItemModal: false,
        })
    }

    CloseGlobalSettingsResponseModal = () => {
        this.setState({
            showGlobalSettingsResponseModal: false,
        })
    }

    ShowDeleteConfirmationModal = () => {
        this.setState({
            loadingAction: false,
            showDeleteConfirmationModal: true,
            DeleteConfirmationModalMessage: `Are you sure you want to delete <strong>${this.state.pageWiseSelectedRows[0].selectedRow.length}</strong> selected allowed/blocked item(s)?<small class="form-text text-muted pt-3"><strong>Note: </strong>Delete action may take some time to reflect in our systems.</small>`
        })
    }

    DeleteAllowedBlockedHandler = () => {
        let selectedItemsBody = []
        this.state.pageWiseSelectedRows.forEach((eachPage) => {
            eachPage.selectedRow.forEach((eachRow) => {
                selectedItemsBody.push({
                    "itemId": eachRow.id,
                    "tenantId": eachRow.tenant.id,
                    "allowed": eachRow.allowedBlockedName === "Allowed",
                    "itemType": eachRow.type,
                    "itemValue": eachRow.properties[eachRow.type], 
                    "dataRegion": eachRow.tenant.dataRegion 
                })
            })
        })
        let requestBody = {
            "items": selectedItemsBody,
        }
        this.setState({
            loadingAction: false,
            showDeleteConfirmationModal: false,
            //DeleteConfirmationModalMessage: `Are you sure you want to delete <strong>${this.state.pageWiseSelectedRows[0].selectedRow.length}</strong> selected endpoint(s)?<small class="form-text text-muted pt-3"><strong>Note: </strong>Delete action may take some time to reflect in our systems.</small>`
        }, () => {
            sendRequestAllowedBlockedDelete(
                this.props.referrerHostname + "_" + localStorage.getItem(this.props.referrerHostname + "_kaseya_tenant_id"),
                requestBody,
                this.props.location.search
            )
                .then(res => {
                    this.setState({
                        loadingAction: false,
                        clearSelection: !this.state.clearSelection,
                        showGlobalSettingsResponseModal: true,
                        messageGlobalSettingsResponseModal: "Deletion request received successfully."
                    })
                    setTimeout(() => {
                        this.getAllowedBlockedData()
                    }, 1000)
                })
                .catch((err) => {
                    let errMessage = ""
                    if (err.response) {
                        if (err.response.data.message !== undefined)
                            errMessage = err.response.data.message
                        else
                            errMessage = "Something went wrong; Please try again later."
                    }
                    else {
                        errMessage = "Something went wrong; Please try again later."
                    }
                    this.setState({
                        loadingAction: false,
                        showErrorActionAllowedBlocked: true,
                        actionAllowedBlockedMessage: errMessage,
                    })
                })
        })
    }

    CloseDeleteConfirmationModal = () => {
        this.setState({
            showDeleteConfirmationModal: false
        })
    }

    render() {
        let tenantCheck = this.state.filtered.find((arrayValue) => this.findFilterValueByType(arrayValue, CONSTANT_TYPE.selectedTenant))
        let checkTenantDetails;
        if (tenantCheck)
            checkTenantDetails = this.props.tenants.tenant_list.find((tenantValue) => tenantValue.id === tenantCheck.value)

        const tenantsWithDataRegionNull = [];
        let clearTenantSelect = false;
        this.props.tenants.tenant_list.forEach((tenant) => {
            if (
                NULL_UNDEFINED_EMPTY_CHECK.includes(tenant.dataRegion) ||
                NULL_UNDEFINED_EMPTY_CHECK.includes(tenant.apiHost)
            ) {
                tenantsWithDataRegionNull.push(tenant.id);
            }
        });
        let selectedTenantId = this.state.filtered.find(
            (arrayValue) => arrayValue.type === CONSTANT_TYPE.selectedTenant
        );
        if (
            selectedTenantId &&
            tenantsWithDataRegionNull.length &&
            tenantsWithDataRegionNull.filter(
                (item) => item === selectedTenantId.value
            ).length
        ) {
            clearTenantSelect = true;
        }

        let messageForForceSync = this.props.settings?.SophosIdTypeIsTenant ? this.props.allowed_blocked && this.props.allowed_blocked.last_updated_times && this.props.allowed_blocked.last_updated_times[this.props.settings?.SophosTenantId] ? 'Last Force Sync Time: ' + moment.unix(this.props.allowed_blocked.last_updated_times[this.props.settings?.SophosTenantId]).format('YYYY-MM-DD HH:mm:ss') : '' : selectedTenantId && selectedTenantId.value && this.props.allowed_blocked.last_updated_times && this.props.allowed_blocked.last_updated_times[selectedTenantId.value] ? 'Last Force Sync Time: ' + moment.unix(this.props.allowed_blocked.last_updated_times[selectedTenantId.value]).format('YYYY-MM-DD HH:mm:ss') : ''
        
        return (
            <CommonLayout title="Allowed and Blocked Items" displayTitle={true}>
                <ErrorModal
                    show={this.props.tenants.error_response_message !== null || this.props.allowed_blocked.error_response_message !== null}
                    closeModal={() => {
                        this.props.tenants.error_response_message !== null ?
                            this.clearTenantErrorResponseToast()
                            :
                            this.clearErrorResponseToast()
                    }}
                    modalMessage={
                        this.props.tenants.error_response_message !== null && this.props.allowed_blocked.error_response_message === null ?
                            this.props.tenants.error_response_message
                            :
                            this.props.allowed_blocked.error_response_message}
                />
                <ErrorModal
                    show={this.state.showErrorActionAllowedBlocked}
                    closeModal={this.closeActionAllowedBlocked}
                    modalMessage={this.state.actionAllowedBlockedMessage}
                />
                <ActionLoadingModal show={this.state.loadingAction} />
                <ConfirmationModal
                    show={this.state.showDeleteConfirmationModal}
                    confirmAction={() => this.DeleteAllowedBlockedHandler()}
                    closeModal={this.CloseDeleteConfirmationModal}
                    modalMessage={this.state.DeleteConfirmationModalMessage}
                />
                <AddAllowedBlockedItemModal
                    {...this.props}
                    show={this.state.showAddAllowedBlockedItemModal}
                    closeModal={this.CloseAllowedBlockedAction}
                    confirmModal={this.AddAllowedBlockedActionHandler}
                    ref={this.addAllowedBlockedModalRef}
                />
                <UpdateAllowedBlockedItemModal
                    {...this.props}
                    show={this.state.showUpdateAllowedBlockedItemModal}
                    update_data={this.state.selectedAllowedBlockedBody}
                    closeModal={this.CloseUpdateAllowedBlockedAction}
                    confirmModal={this.UpdateAllowedBlockedActionHandler}
                />
                <GlobalSettingsResponseModal
                    {...this.props}
                    show={this.state.showGlobalSettingsResponseModal}
                    closeModal={this.CloseGlobalSettingsResponseModal}
                    message={this.state.messageGlobalSettingsResponseModal}
                />
                <ToastContainer
                    position="top-right"
                    autoClose={7000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    draggable={false}
                    pauseOnHover={false}
                    enableMultiContainer
                    containerId={'A'}
                />
                <div className="row mt-2 mx-1">
                    <div className="col-8">
                        <div className="input-group-append row">
                            {!this.props.settings.SophosIdTypeIsTenant &&
                                <div className="col-sm-2 px-0 mx-1 text-left mb-2">
                                    <div className="col-sm-12 px-0 mx-1 text-left">
                                        <span>Tenants</span>
                                        <MultiSelectTextbox
                                            options={this.state.tenantList.sort(sortingData)}
                                            isMulti={false}
                                            filteredSelectedValue={
                                                this.state.filtered.find((arrayValue) =>
                                                    this.findFilterValueByType(arrayValue, CONSTANT_TYPE.selectedTenant)) ?
                                                    this.state.tenantList.filter((element) => element.value === this.state.filtered.find((arrayValue) =>
                                                        this.findFilterValueByType(arrayValue, CONSTANT_TYPE.selectedTenant)).value)
                                                    : []
                                            }
                                            onSelectOption={(value) => this.selectFilters(value, CONSTANT_TYPE.selectedTenant)}
                                            clearValue={this.state.clearFilterBool}
                                            clearable={true}
                                            isLoading={this.props.tenants.is_loading}
                                            disabledSelect={this.props.allowed_blocked.is_loading}
                                        />
                                    </div>
                                </div>}
                            <div className="col-sm-2 px-0 mx-1 text-left mb-2">
                                <span>Allowed/Blocked</span>
                                <MultiSelectTextbox
                                    options={allowedBlockedOptions}
                                    isMulti={false}
                                    filteredSelectedValue={
                                        this.state.filtered.find((arrayValue) =>
                                            this.findFilterValueByType(arrayValue, CONSTANT_TYPE.allowedBlocked))
                                    }
                                    onSelectOption={(value) => this.selectFilters(value, CONSTANT_TYPE.allowedBlocked)}
                                    clearable={true}
                                    clearValue={this.state.clearFilterBool}
                                />
                            </div>
                            <div className="col-sm-2 px-0 mx-1 text-left">
                                <span>Type</span>
                                <MultiSelectTextbox
                                    options={ALLOWED_TYPE_OPTIONS}
                                    isMulti={false}
                                    filteredSelectedValue={
                                        this.state.filtered.find((arrayValue) =>
                                            this.findFilterValueByType(arrayValue, CONSTANT_TYPE.type))
                                    }
                                    onSelectOption={(value) => this.selectFilters(value, CONSTANT_TYPE.type)}
                                    clearable={true}
                                    clearValue={this.state.clearFilterBool}
                                />
                            </div>
                            <div className="col-sm-2 px-0 mx-1 text-left">
                                <span>Machine name</span>
                                <input
                                    type="text"
                                    id="machine_name"
                                    className="form-control-sm"
                                    style={{ border: '1px solid #ccc', width: '130px' }}
                                    value={this.state.machineName}
                                    onChange={(event) => this.selectFilters(event.target.value, CONSTANT_TYPE.machineName)}
                                />
                            </div>
                            <div className="col-1 text-left mt-3">
                                <button type="button" className="btn btn-secondary btn-sm ml-2" disabled={this.props.allowed_blocked.is_loading} onClick={this.clearFilter.bind(this)}>Clear</button>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-4 justify-content-end flex pt-3 pr-0" style={{ display: "flex" }}>
                        <button type="button" style={{ maxHeight: "29px" }} className="btn btn-primary btn-sm mr-2" onClick={this.AddAllowedBlockedAction}>
                            Add
                        </button>
                        <button disabled={!(this.state.selectedAllowedBlockedBody && this.state.selectedAllowedBlockedBody.length === 1 && this.state.selectedAllowedBlockedBody[0]["allowedBlockedName"] === "Allowed")} type="button" style={{ maxHeight: "29px" }} className="btn btn-primary btn-sm mr-2" onClick={this.UpdateAllowedBlockedAction}>
                            Update
                        </button>
                        <button disabled={!(this.state.selectedAllowedBlockedBody && this.state.selectedAllowedBlockedBody.length > 0)} type="button" style={{ maxHeight: "29px" }} className="btn btn-primary btn-sm mr-2" onClick={this.ShowDeleteConfirmationModal}>
                            Delete
                        </button>
                        <button type="button" style={{ maxHeight: "29px" }} className="btn btn-outline-primary btn-sm" disabled={((tenantCheck === undefined || checkTenantDetails === undefined) && !this.props.settings.SophosIdTypeIsTenant) || clearTenantSelect} onClick={this.getAllowedBlockedData.bind(this, false, false, true)}><i className="fa fa-refresh" /> Force Sync</button>
                        <button type="button" style={{ maxHeight: "29px" }} className="btn btn-primary round-help-btn ml-2 btn-sm" data-tip={this.props.allowed_blocked.req_per_hour !== null ? `Maximum of ${this.props.allowed_blocked.req_per_hour}x per hour allowed. ${!this.props.settings.SophosIdTypeIsTenant ? "Select a tenant to enable Force Sync." : ""}` : `Maximum of 4x per hour allowed. ${!this.props.settings.SophosIdTypeIsTenant ? "Select a tenant to enable Force Sync." : ""}`} data-for='helpTime'><i className="fa fa-question" /></button>
                        <ReactTooltip id="helpTime" effect="solid" type="info" place="left" />
                    </div>
                </div>
                <div className="row mt-2 mx-1">
                    <div className="col-12 text-right">
                        <b>{messageForForceSync}</b>
                    </div>
                </div>
                <div className="row m-1 card-content-height">
                    <div className="col-md-12 pr-1">
                        <TableGrid
                            clearValue={this.state.clearFilterBool}
                            defaultSortedCol={this.state.defaultSorted}
                            columnStructure={this.state.columnDefs}
                            responseData={this.filterData(this.state.rowData)}
                            loading={this.props.allowed_blocked.is_loading}
                            stateObject={this.props.allowed_blocked}
                            pageSize={this.filterData(this.state.rowData).length < this.props.allowed_blocked.page_size ? this.filterData(this.state.rowData).length : this.props.allowed_blocked.page_size}
                            filtered={this.state.filtered}
                            noDataText={this.tablegridMessage()}
                            keyField="_id"
                            moduleName="allowedBlocked"
                            clearSearchBox={this.state.clearSearchBox}
                            note="Allowed/Blocked Items will be displayed in some time if you have configured settings recently."
                            singleSelectedRow={(selectedId) => this.getAllowedBlockedSelectedId(selectedId)}
                            pageWiseSelectedRowsFromTable={(currentPage, selectedRowData) => this.getPageWiseSelectedRowsFromTable(currentPage, selectedRowData)}
                            onPageChangeEvent={(page) => this.setTablePage(page)}
                            nonSelectableRows={this.getNonSelectableRows(this.filterData(this.state.rowData))}
                            onSortChange={this.state.sortChangeBool}
                            onPerformAction={this.state.clearSelection}
                        />
                    </div>
                </div>
            </CommonLayout>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AllowedBlockedItems)
